module.exports = __webpack_public_path__ + "static/media/DP_Embroidery_Vela_DK Grey_White.f3b6502c.png";